import { Form } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';

import { FilterByLocation } from 'components';
import { allLocations } from 'constants/regions';
import { compareFieldArray } from '../../utils';

const SavedSearchSettingsUpsertLocations = () => {
  const { t } = useTranslation();

  return (
    <Form.Field isEqual={compareFieldArray} name="locations">
      {({ input }) => (
        <FilterByLocation
          onChange={input.onChange}
          values={input.value}
          availableValues={allLocations}
          label={t('opportunities.filters.location')}
          TextFieldProps={{ fullWidth: true }}
        />
      )}
    </Form.Field>
  );
};

export default SavedSearchSettingsUpsertLocations;
